import { render } from "./FormIncentives.vue?vue&type=template&id=28b12362&scoped=true"
import script from "./FormIncentives.vue?vue&type=script&lang=js"
export * from "./FormIncentives.vue?vue&type=script&lang=js"

import "./FormIncentives.vue?vue&type=style&index=0&id=28b12362&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-28b12362"

export default script